import { render, staticRenderFns } from "./DivideItRightPreview.vue?vue&type=template&id=820d66a4&lang=pug&"
import script from "./DivideItRightPreview.vue?vue&type=script&lang=js&"
export * from "./DivideItRightPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports